import { AI_MESSAGE_ATTRIBUTE } from '@shared/constants/ai-messages'
import { IMessage } from '@shared/models/proto/base/messages'
import { isGptBotPayload } from '@shared/utils/helpers/messages/bot-payload'

export const isMessageToAi = (messages: IMessage[], index: number): boolean => {
  const prevMessage = messages[index - 1]

  return isGptBotPayload(prevMessage)
}

export const isMessageSendToAi = (text: string): boolean =>
  text.includes(`data-message="${AI_MESSAGE_ATTRIBUTE}"`)
